import Can, { CanWithRole, hasPermission, checkRoles } from './Can';
import PrivateRoute from './PrivateRoute';

export * from 'constants/permissions';
export {
  CanWithRole, PrivateRoute, hasPermission, checkRoles,
};
export default Can;
